<script>
  // A label/value row for detail panels. Value goes in the default slot so it can be
  // text, a Badge, a link, etc.
  //   <PropertyRow label="Email">{user.email}</PropertyRow>
  let { label, children } = $props()
</script>

<div class="flex items-baseline justify-between gap-3 py-1.5 text-sm border-b border-base-200 last:border-0">
  <span class="text-base-content/50 shrink-0">{label}</span>
  <span class="text-right min-w-0">{@render children()}</span>
</div>
